<template>
  <div class="home">
    <div class="header">
      <img src="//pic1.58cdn.com.cn/nowater/jltx/n_v2dcca6a89e1aa4043885e299bd95755f0.png" alt />
    </div>
    <!-- <base-swiper :city_name='city_name' :itemList='topList'></base-swiper> -->
    <div class="item-box">
      <base-nav :navList="navList" :hideTitleArray="hideTitle" @changeTab="changeTab"></base-nav>
      <base-list :title="'销售专场'" :itemList="list1" v-show="activeIndex ===0"></base-list>
      <base-list :title="'美容美发'" :itemList="list2" v-show="activeIndex ===1"></base-list>
      <base-list :title="'客服专场'" :itemList="list3" v-show="activeIndex ===2"></base-list>
      <base-list :title="'普工专场'" :itemList="list4" v-show="activeIndex ===3"></base-list>
      <base-list :title="'教育专场'" :itemList="list5" v-show="activeIndex ===4"></base-list>
      <base-list :title="'人气热招'" :itemList="list6" v-show="activeIndex ===5"></base-list>
      <base-list :title="'餐饮专场'" :itemList="list7" v-show="activeIndex ===6"></base-list>
    </div>
    <!-- <div class="back-top" @click="backToTop">
      <div>
        <img src="//pic1.58cdn.com.cn/nowater/jltx/n_v23707d8f1368544bc9fed8f69d4ba5f62.png" alt>
      </div>
    </div>-->
    <!-- <a href="//hrgbot.58.com/mchat"> -->
    <!-- <div class="robot" @click="toRobot">
      <div>
        <img src="//pic1.58cdn.com.cn/nowater/jltx/n_v25af17a042504477193947cbdf6756e40.png" alt />
      </div>
    </div>-->
    <!-- </a> -->
  </div>
</template>

<script>
import data from "./../../mock/mock.js";
import baseNav from "./../base/baseNav.vue";
import baseList from "./../base/baseList.vue";
// import baseSwiper from './../base/baseSwiper.vue'
export default {
  name: "home",
  components: {
    baseNav,
    baseList
    // baseSwiper
  },
  data() {
    return {
      m_data: null,
      pageDataDetail: null,
      city_name: null,
      activeIndex: 0,
      // navList: ['销售专场','美容美发','客服专场','普工专场','教育培训','人气热招','餐饮专场'],
      navList: [],
      topList: [],
      list1: [],
      list2: [],
      list3: [],
      list4: [],
      list5: [],
      list6: [],
      list7: [],
      // img6:  require("../assets/img/img_xs.png"), //销售
      // img7:  require("../assets/img/img_mr.png"), //美容
      // img8:  require("../assets/img/img_kf.png"), // 客服
      // img9:  require("../assets/img/img_pg.png"), // 普工
      // img10:  require("../assets/img/img_jy.png"), // 教育
      // img11:  require("../assets/img/img_rq.png"), // 人气
      // img12:  require("../assets/img/img_cy.png"), // 餐饮
      hideTitle: Array(7).fill(true)
    };
  },
  created() {
    process.env.NODE_ENV == "development" && (window.m_data = data);
    this.m_data = m_data;
    this.pageDataDetail = m_data.pageDataDetail;
    this.city_name = m_data.city_name;
    this.navList = m_data.pageDataList.filter(
      item => item.modelType === "otherTabs"
    )[0].itemList;
    this.handleList();
  },
  mounted() {},
  methods: {
    changeTab(val) {
      this.activeIndex = val;
    },
    handleList() {
      this.pageDataDetail.forEach(item => {
        switch (item.type) {
          case 6:
            this.hideTitle[0] = false;
            this.list1.push(item);
            break;
          case 7:
            this.hideTitle[1] = false;
            this.list2.push(item);
            break;
          case 8:
            this.hideTitle[2] = false;
            this.list3.push(item);
            break;
          case 9:
            this.hideTitle[3] = false;
            this.list4.push(item);
            break;
          case 10:
            this.hideTitle[4] = false;
            this.list5.push(item);
            break;
          case 11:
            this.hideTitle[5] = false;
            this.list6.push(item);
            break;
          case 12:
            this.hideTitle[6] = false;
            this.list7.push(item);
            break;
          default:
            return;
        }
      });
    },
    backToTop() {
      let dom = document.querySelector(".header");
      dom.scrollIntoView({
        behavior: "smooth"
      });
    },
    toRobot() {
      const appUrl = "//hrgbot.58.com/mchat";
      const mUrl = "//hrgbot.58.com/mcommonchat";
      if (window.WBAPP) {
        WBAPP.action.pagetrans("core", {
          pagetype: "common", // 必填
          url: appUrl, // 必填
          title: "" // 选填，无则会自动识别dom中的title值
        });
        return;
      }
      window.location.href = mUrl;
    }
  },
  computed: {
    //     swiper() {
    //         return this.$refs.mySwiper.swiper
    // }
  }
};
</script>

<style lang="less">
.home {
  height: 100%;
  .header {
    background: #fff;
    position: relative;
    z-index: -1;
    img {
      width: 100%;
      min-height: 6.8rem;
      display: block;
    }
  }
  .item-box {
    position: relative;
    background: url(//pic1.58cdn.com.cn/nowater/jltx/n_v2cc9a4600f80b480eb4afb88f099245dd.png)
      no-repeat center top;
    background-size: cover;
    min-height: 80%;
    &:after {
      display: block;
      content: "";
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 2rem;
      background: url(//pic1.58cdn.com.cn/nowater/jltx/n_v2f37d59b8424443368c63fb2b78bff880.png)
        no-repeat;
      background-size: cover;
    }
  }
}

//
.back-top,
.robot {
  width: 1.506667rem;
  height: 1.506667rem;
  position: fixed;
  right: 0;
  bottom: 5.666667rem;
  z-index: 1000;
  visibility: visible;
  cursor: pointer;
  // ios抖动问题
  // position: absolute;
  -webkit-transform: translateZ(0);
  div {
    position: relative;
    width: 100%;
    height: 100%;
  }
  img {
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue